import ContentLoading from "component/LoadingComponent/ContentLoading";
import { API_BASE_URL } from "configs/AppConfig";
import { END_POINTS } from "constants/APIConstant";
import { DEFAULTS } from "constants/Defaults";
import { DateFormater } from "functions/dateTimeFormat";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { UNDEFINED } from "swr/_internal";
import NewsCardItems from "./components/news-card-items";
import PinnedCardItem from "./components/pinned-card-item";
import "./mediaLandingNews.scss";
import HtmlView from "component/htmlView/html-view";
import CustomizedDatePicker from "component/customizedDatePicker/customized-date-picker";
import Paginator from "component/shared/Paginator/Paginator";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { TRANSLATION_KEYS } from "constants/TranslationConstant";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";

const Linkable = ({ children, data, className }) => {
  return data !== null && data !== UNDEFINED && data.data.length > 0 ? (
    <Link to={`/mediaLanding/news/${data.data[0].id}`} className={className}>
      {children}
    </Link>
  ) : (
    <div className={className}></div>
  );
};
function MediaLandingNews() {
  const intl = useIntl();


  ReactGA.initialize(END_POINTS.TRACKING_ID);

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/mediaLanding/news", title: "News Page" });
  }, []);


  const currentLocale = useSelector(({ theme }) => theme.locale);
  const [newsTabToggle, setNewsTabToggle] = useState(0);
  const defaultState = {
    pageSize: 5,
    currentPage: 1,
    startDate: null,
    endDate: null,
    title: null,
    categoryId: null,
  };

  const [filters, setFilters] = useState(defaultState);
  const [date, setDate] = useState({ startDate: "", endDate: "", title: "" });

  const tabNews = (index, id) => {
    setNewsTabToggle(index);
    setFilters((prevState) => {
      return { ...prevState, currentPage: 1, categoryId: id };
    });
  };

  const onDateFilterChange = (passedValue, name) => {
    const value = passedValue === "" ? null : passedValue;
    // setDate((prevState) => ({
    //   ...prevState,
    //   [name]: value ?? "",
    // }));
    setFilters((prevState) => ({
      ...prevState,
      [name]: value ?? "",
    }));
  };
  const onFilterChange = (e) => {
    const { name, value } = e.target;
    setDate((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const onPageIndexChange = (e, value) => {
    setFilters((prevState) => ({
      ...prevState,
      currentPage: value,
    }));
  };

  const newsDataFetching = useSWR({
    url: `${END_POINTS.NEWS_SEARCH}`,
    params: filters,
  });
  const newsCategoriesDataFetching = useSWR({
    url: END_POINTS.NEWS_CATEGORIES,
  });
  const newsPinnedFetching = useSWR({
    url: END_POINTS.NEWS_GET_PINNED,
  });

  const renderNewsCard = () => {
    const newsData =
      newsDataFetching.error ||
      newsDataFetching.isLoading ||
      newsDataFetching.data === undefined
        ? []
        : newsDataFetching.data.data;
    const rendering =
      Object.keys(newsData).length > 0 ? (
        <Paginator
          size={filters.pageSize}
          page={filters.currentPage}
          totalCount={newsDataFetching?.data?.page?.totalCount}
          change={onPageIndexChange}
        >
          {newsData.map(
            (
              {
                id,
                title,
                brief,
                content,
                image,
                publishDate,
                newsTranslation,
              },
              i
            ) => (
              <div key={i}>
                <NewsCardItems
                  image={image}
                  title={title}
                  description={brief}
                  publicationDate={publishDate}
                  id={id}
                  translations={newsTranslation}
                />
              </div>
            )
          )}
        </Paginator>
      ) : (
        <DataNotFound />
      );

    return rendering;
  };
  const renderNewsCategory = () => {
    const newsCategoryData =
      !newsCategoriesDataFetching ||
      newsCategoriesDataFetching.error ||
      newsCategoriesDataFetching.isLoading ||
      newsCategoriesDataFetching.data === undefined
        ? []
        : newsCategoriesDataFetching.data.data;
    const rendering = newsCategoryData.map(
      ({ id, categoryName, categoryTranslation }, index) => {
        return (
          <li
            className={newsTabToggle === index + 1 ? "active" : "item"}
            onClick={() => tabNews(index + 1, id)}
            key={id}
          >
            <LabelLang
              id="categoryName"
              defaultValue={categoryName}
              translations={categoryTranslation}
            />
          </li>
        );
      }
    );
    const defaultPagnation = (
      <li
        className={newsTabToggle === 0 ? "active" : "item"}
        onClick={() => tabNews(0, 0)}
        key={"media-landing-news-default"}
      >
        <FormattedMessage id="all-news" />{" "}
      </li>
    );
    const renderingList = [defaultPagnation, ...rendering];
    const paginatedList = <div className="news-list">{renderingList}</div>;
    return Object.keys(newsCategoryData).length > 0 ? (
      paginatedList
    ) : (
      <DataNotFound />
    );
  };

  const RenderPinnedData = () => {
    const newsData =
      // newsPinnedFetching.error ||
      newsPinnedFetching.isLoading ||
      newsPinnedFetching.data === undefined ||
      newsPinnedFetching.data.data.length <= 1
        ? []
        : newsPinnedFetching.data.data.slice(1, 6);
    const rendering =
      Object.keys(newsData).length > 0 &&
      newsData.map(
        (
          { id, title, brief, content, image, publishDate, newsTranslation },
          index
        ) => {
          return (
            <PinnedCardItem
              key={index}
              image={image}
              title={title}
              description={brief}
              publicationDate={publishDate}
              translations={newsTranslation}
              id={id}
            />
          );
        }
      );

    return rendering;
  };

  return (
    <ContentLoading
      isLoading={
        newsDataFetching.isLoading ||
        newsCategoriesDataFetching.isLoading ||
        newsPinnedFetching.isLoading
      }
    >
      <div className="row">
        <div className="col-12 col-lg-12">
          <div className="news-c">
            {newsPinnedFetching?.data?.data[0] ? (
              <Linkable data={newsPinnedFetching.data} className="item-news">
                <img
                  className="up w-100"
                  src={
                    newsPinnedFetching.data !== undefined &&
                    newsPinnedFetching.data?.data[0]?.image
                      ? `${API_BASE_URL}/${newsPinnedFetching.data?.data[0]?.image}`
                      : DEFAULTS.NEWS
                  }
                  alt="img-item"
                  loading="lazy"
                />
                <div className="main-pinned-card">
                  <div className="top-content">
                    <h5>
                      <DateFormater
                        value={
                          newsPinnedFetching.data === undefined
                            ? null
                            : newsPinnedFetching.data?.data[0]?.publishDate
                        }
                      />
                    </h5>
                    <h3 className={"title"}>
                      {newsPinnedFetching.data === undefined ? (
                        ""
                      ) : (
                        <LabelLang
                          id="title"
                          defaultValue={newsPinnedFetching.data?.data[0]?.title}
                          translations={
                            newsPinnedFetching.data?.data[0][
                              TRANSLATION_KEYS.NEWS
                            ]
                          }
                        />
                      )}
                    </h3>
                    {newsPinnedFetching.data === undefined ? (
                      ""
                    ) : (
                      <HtmlView
                        html={
                          newsPinnedFetching.data === undefined ? (
                            <></>
                          ) : (
                            LabelLangString({
                              id: "content",
                              currentLocale: currentLocale,
                              defaultValue:
                                newsPinnedFetching.data?.data[0]?.content,
                              translations:
                                newsPinnedFetching.data.data[0][
                                  TRANSLATION_KEYS.NEWS
                                ],
                            })
                          )
                        }
                      />
                    )}
                  </div>
                  <div className="rev-item">
                    <div className="more">
                      <span>
                        <FormattedMessage id="read-news" />
                      </span>
                      <i className="fas fa-ellipsis-h"></i>
                    </div>
                  </div>
                </div>
              </Linkable>
            ) : (
              <DataNotFound />
            )}

            <div className="pinned-items">
              <RenderPinnedData />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        {/* TITLE*/}
        <div className="col-12">
          <div className="m__title">
            <h3> </h3>
          </div>
        </div>

        {/* CHOOSE*/}
        <div className="col-12 col-lg-4">
          <form
            className="form-search"
            onSubmit={() => {
              setFilters((prev) => {
                return { ...prev, title: date.title };
              });
            }}
          >
            <input
              type="text"
              name="title"
              placeholder={intl.formatMessage({
                id: "search-using-search-term",
              })}
              value={date.title}
              onChange={onFilterChange}
            />
            <div className="row-r mt-4">
              <button className="main-btn" type="submit">
                <span>
                  <FormattedMessage id="search" />{" "}
                </span>
              </button>
            </div>
          </form>
          <div className="searchBy-ob">
            <h5>
              <b>
                <FormattedMessage id="explore-with-news-type" />:
              </b>
            </h5>
            <ul>{renderNewsCategory()}</ul>
          </div>
        </div>

        {/* TABLE*/}
        <div className="col-12 col-lg-8">
          <div className="news-tabs">
            <div className="active-item-news-tabs">
              <div className="body-news">
                <div className="row">
                  <div className="col-12 text-danger fw-bolder">
                    <p>
                      <FormattedMessage id="choose-date-then-enter" />
                    </p>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-label">
                      <label className="ps-3">
                        <FormattedMessage id="news-from" />
                      </label>
                      <div className="form-label-container">
                        <CustomizedDatePicker
                          dateFormat="dd/MM/yyyy"
                          name={"startDate"}
                          value={date.startDate}
                          onChange={(e) => {
                            const value =
                              e.target.value === "" ? null : e.target.value;
                            setDate((prevState) => ({
                              ...prevState,
                              [e.target.name]: value ?? "",
                            }));
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              onDateFilterChange(date.startDate, "startDate");
                              onDateFilterChange(date.endDate, "endDate");
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-label">
                      <label className="ps-3">
                        <FormattedMessage id="to" />
                      </label>
                      <div className="form-label-container">
                        <CustomizedDatePicker
                          dateFormat="dd/MM/yyyy"
                          name={"endDate"}
                          value={date.endDate}
                          onChange={(e) => {
                            const value =
                              e.target.value === "" ? null : e.target.value;
                            setDate((prevState) => ({
                              ...prevState,
                              [e.target.name]: value ?? "",
                            }));
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              onDateFilterChange(date.startDate, "startDate");
                              onDateFilterChange(date.endDate, "endDate");
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row-r mb-4">
                      <button
                        className="main-btn"
                        onClick={() => {
                          onDateFilterChange(date.startDate, "startDate");
                          onDateFilterChange(date.endDate, "endDate");
                        }}
                      >
                        <span>
                          <FormattedMessage id="search" />
                        </span>
                      </button>
                    </div>
                  </div>
                  {renderNewsCard()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default MediaLandingNews;
